import { formatDate } from "../../../../lib/utils";
import { useNavigate } from "react-router";
import { MapPinIcon } from "@heroicons/react/24/outline";
import { EventFragment } from "../../../../__generated__/graphql";
import useSignedUrlToGetFile from "../../../../hooks/useSignedUrlToGetFile";
import EventDraftButton from "../../../../components/EventDetails/components/EventDraftButton";

interface EventCardProps {
  event: EventFragment;
}

export default function EventCardWithTickets({ event }: EventCardProps) {
  const navigate = useNavigate();
  const { data: signedUrlData } = useSignedUrlToGetFile(event.imageBucketKey);

  const imageUrl =
    signedUrlData?.signedUrlToGetFile ||
    event.eventLocation?.location.photoUrls?.[0] ||
    undefined;

  return (
    <div
      className="flex flex-col gap-2 w-[320px] bg-card rounded-md cursor-pointer hover:bg-card/50 transition-all duration-300 border border-border"
      onClick={() => {
        navigate(`/events/${event.id}`);
      }}
    >
      {imageUrl ? (
        <img
          src={imageUrl}
          alt="Event image"
          className="w-full h-40 object-cover rounded-t-md"
        />
      ) : (
        <div className="w-full h-40 bg-subCard rounded-t-md" />
      )}

      <div className="flex flex-col gap-2 p-2">
        <div>
          <div className="text-xl font-semibold text-primary">{event.name}</div>
          <div className="flex gap-2 items-center">
            <EventDraftButton event={event} variant="small" readonly />
            <div className="text-sm text-secondary flex gap-2 items-center">
              {formatDate(event.startDate)}
            </div>
          </div>
        </div>

        <div className="text-sm text-secondary">{event.description}</div>
        {event.eventLocation?.location?.label ? (
          <div className="flex gap-2 items-center">
            <div>
              <MapPinIcon className="w-4 h-4 text-secondary" />
            </div>
            <div className="flex flex-col gap-1">
              <div className="text-sm text-primary">
                {event.eventLocation?.location?.label}
              </div>
              <div className="text-sm text-secondary">
                {event.eventLocation?.location?.address}{" "}
                {event.eventLocation?.location?.zipCode}{" "}
                {event.eventLocation?.location?.city}
              </div>
            </div>
          </div>
        ) : null}
        {/* {eventFilling({
          maxCapacity: event.maxCapacity,
          // Get the data from the last event ticket as it contains the total sold tickets
          totalSoldTickets: event.eventTickets?.length
            ? event.eventTickets[event.eventTickets.length - 1]?.soldTickets
            : 0,
        })} */}
      </div>
    </div>
  );
}
